import React, {
  useContext, useEffect, useState, useCallback,
} from 'react';
import { CardShowcase } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { withRouter } from '@americanexpress/one-app-router';
import Wrapper from '../components/Wrapper';
import { PaymentContext } from '../utility/PaymentContext';
import { TokenContext } from '../utility/TokenContext';
import useApiWithSession from '../utility/useApiWithSession';
import withScrollToTop from '../utility/withScrollToTop';

// Helper: Error messages by level
const ERROR_MESSAGES = {
  1: 'Your visual session has ended.',
  2: 'Your visual session has ended.',
  3: 'Your visual session has ended.',
};

// Helper: Delete session_id cookie with all possible attribute combinations
const deleteSessionCookie = () => {
  const cookieBase = 'session_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  const domain = window.location.hostname;
  document.cookie = `${cookieBase}; path=/; SameSite=Strict`;
  document.cookie = `${cookieBase}; path=/`;
  document.cookie = `${cookieBase}`;
  document.cookie = `${cookieBase}; path=/; SameSite=Strict; domain=${domain}`;
  document.cookie = `${cookieBase}; path=/; domain=${domain}`;
  document.cookie = `${cookieBase}; domain=${domain}`;
};

const ErrorScreen = ({ location }) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const {
    sid1, market1, journey1, setSid1, setPaymentResponse, u1,
  } = useContext(PaymentContext);
  const { gateWayUrl } = useContext(TokenContext);
  const { query } = location;
  const { level } = query;

  const { run } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: 'ERROR_APP' },
    customHeaders: {
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
  });

  // Error handling and session cleanup
  const handleError = useCallback(async () => {
    setErrorMsg(ERROR_MESSAGES[level] || ERROR_MESSAGES['3']);
    if (level !== '1' && level !== '2') {
      await run();
    }
    deleteSessionCookie();
    setSid1('');
    setPaymentResponse(null);
  }, [level, run, setPaymentResponse, setSid1]);

  useEffect(() => {
    // Disable browser back button
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    handleError();
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <Wrapper>
      <CardShowcase>
        <div className="width-full pad-4" style={{ display: 'grid', gap: '2rem' }}>
          <p className="body-4 text-wrap">
            {errorMsg}
          </p>
        </div>
      </CardShowcase>
    </Wrapper>
  );
};

export default withScrollToTop(withRouter(ErrorScreen));

ErrorScreen.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.instanceOf(Object),
  }).isRequired,
};
